import React, { useRef } from 'react'

import PropTypes from 'prop-types'

import { useLottie, useApplyThemeToLottie } from '@/utils/hooks/useLottie'

import Flex from '@/ui/Flex'

import lottieJSON from '@/assets/lottie-loop.json'

const LottieLoader = ({ size, ...props }) => {
  const loopRef = useRef(null)

  useLottie(lottieJSON, loopRef)
  useApplyThemeToLottie(lottieJSON)

  return (
    <Flex {...props}>
      <Flex
        height={size}
        style={{ backgroundRepeat: 'no-repeat' }}
        ref={loopRef}
      />
    </Flex>
  )
}

LottieLoader.propTypes = {
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default LottieLoader
